import { s as stores } from "./client2.js";
({
  check: stores.updated.check
});
